import { addDays, addMonths, addYears, parse, format, isValid } from "date-fns";
import { useValid } from "@/utils/valid";
import { useFile } from "@/utils/file";

import { useAxios } from "@/utils/axios";
import { useAlert } from "@/utils/alert";

const $valid = useValid();
const $file = useFile();
const $axios = useAxios();
const $alert = useAlert();

const number = {
    addComma(data) {
        let returnData = data;
        if (data) {
            const regexp = /\B(?=(\d{3})+(?!\d))/g;
            returnData = data.toString().replace(regexp, ',');
        }

        return returnData;
    },
    only_keydown(event) {
        event = event || window.event;
        var keyID = (event.which) ? event.which : event.keyCode;
        if (!((keyID >= 48 && keyID <= 57) ||
            (keyID >= 96 && keyID <= 105) ||
            keyID == 8 ||
            keyID == 46 ||
            keyID == 37 ||
            keyID == 39 ||
            keyID == 9)) {
            event.preventDefault();
        }

        event.target.value = event.target.value.replace(/[^0-9]/g, "");
    },
    only_keyup(event) {
        event = event || window.event;
        const keyID = (event.which) ? event.which : event.keyCode;
        if (keyID == 8 || keyID == 46 || keyID == 37 || keyID == 39 || keyID == 9)
            return false;
        else
            event.target.value = event.target.value.replace(/[^0-9]/g, "");
    },
    only(data) {
        if (data === null || data === undefined) {
            data = '';
        }
        return data.toString().replace(/\D/g, '');
    },
}

const txt = {
    tlnos: ['02', '031', '032', '033', '041', '042', '043', '044', '050', '051', '052', '053', '054', '055', '061', '062', '063', '064', '070', '0503', '0504', '0505', '0508', '0509', '010'],
    mbpns: ['010', '011', '016', '017', '018', '019'],
    emails: [
        { val: '', lab: '직접입력' },
        { val: 'naver.com', lab: '네이버' },
        { val: 'gmail.com', lab: '구글' },
        { val: 'hanmail.net', lab: '다음' },
        { val: 'nate.com', lab: '네이트' },
    ],
    srchs: [
        { se: '001', nm: '제목' },
        { se: '002', nm: '내용' },
        { se: '003', nm: '제목 + 내용' },
    ],
    createQueryStr(params, prefix) {
        const queryString = Object.keys(params).map(key => {
            const value = params[key];

            let newKey = '';
            if (prefix) newKey += prefix + '.';
            newKey += key;

            if (value !== null && typeof value === 'object') {
                return txt.createQueryStr(value, newKey);
            } else {
                return encodeURIComponent(newKey) + '=' + encodeURIComponent(value);
            }
        }).join('&');

        return queryString;
    },
    async setCnImgSrc(cn, cnImgFiles) {
        let setCn = cn;

        for (const file of cnImgFiles) {
            const dwldUrl = await $file.ncp.tcfl.getDwldUrl(file.ncpObjectNm);
            file.dwldUrl = dwldUrl;
            setCn = setCn.replaceAll(file.flnm, dwldUrl);
        }

        return { setCn, setCnImgFiles: cnImgFiles };
    },
    removeSpaces(data) {
        return data.replace(/\s/g, '');
    },
    getBznoFormat(data) {
        let formatData = '';
        if (data) formatData = data.substring(0, 3) + '-' + data.substring(3, 5) + '-' + data.substring(5, 10);
        return formatData;
    },
}

const date = {
    getYmdFormat(ymd, format) {
        let formatData = '';
        if (ymd) {
            if (!$valid.isDate(ymd)) formatData = ymd;
            else formatData = date.getAllFormat('ymd', ymd, format);
        }

        return formatData;
    },
    getYmFormat(ym, format) {
        return date.getAllFormat('ym', ym, format)
    },
    getAllFormat(se, data, format) {
        let formatData = '';

        if (!format) format = '-';

        const yy = data.substring(0, 4);
        const mm = data.substring(4, 6);
        formatData = yy + format + mm;

        let dd = '';
        if (se == 'ymd') {
            dd = data.substring(6, 8);
            formatData += format + dd;
        }

        return formatData;
    },
    getYmdhmsFormat(ymdhms, ymdFormat) {
        let formatData = '';
        if (!ymdFormat) ymdFormat = '-';

        if (ymdhms && ymdhms.length == 14) {
            const ymd = ymdhms.substring(0, 8);
            const hms = ymdhms.substring(8, 14);

            formatData += date.getYmdFormat(ymd, ymdFormat) + ' ';
            formatData += hms.substring(0, 2) + ':' + hms.substring(2, 4) + ':' + hms.substring(4, 6);
        }

        return formatData;
    },
    getYmdKrFormat(ymd) {
        return date.getAllKrFormat('ymd', ymd);
    },
    getYmKrFormat(ym) {
        return date.getAllKrFormat('ym', ym);
    },
    getAllKrFormat(se, data) {
        let formatData = data;

        if (data) {
            const yy = data.substring(0, 4);
            const mm = data.substring(4, 6);
            formatData = yy + '년 ' + mm + '월';

            let dd = '';
            if (se == 'ymd') {
                dd = data.substring(6, 8);
                formatData += ' ' + dd + '일';
            }
        }

        return formatData;
    },
    getAddMtByYmd(ymd, addMt) {
        const date = parse(ymd, 'yyyyMMdd', new Date());
        const calcYmd = addMonths(date, addMt);
        return format(calcYmd, 'yyyyMMdd');
    },
    calc(se, data, calcNum) {
        /* se 종류 => 일: d, 월: m, 년: y */
        if (!se || !data) return '';

        let calcDate = '';
        let formatStr = '';

        if (se == 'd') {
            formatStr = 'yyyyMMdd';
            const ymd = parse(data, formatStr, new Date());
            calcDate = addDays(ymd, calcNum);
        } else if (se == 'm') {
            formatStr = 'yyyyMM';
            const ym = parse(data, formatStr, new Date());
            calcDate = addMonths(ym, calcNum);
        } else if (se == 'y') {
            formatStr = 'yyyy';
            const yy = parse(data, formatStr, new Date());
            calcDate = addYears(yy, calcNum);
        }

        if (!isValid(calcDate)) return '';

        return format(calcDate, formatStr);
    },
    calcDateRange(dateStr1, dateStr2) {
        let dateRange = 0;

        if (!$valid.isDate(dateStr1)
            || !$valid.isDate(dateStr2)) {
            return '올바른 날짜형식을 입력해주세요.';
        }

        // 날짜 형식을 해석합니다.
        const date1 = new Date(dateStr1.slice(0, 4), Number(dateStr1.slice(4, 6)) - 1, dateStr1.slice(6, 8));
        const date2 = new Date(dateStr2.slice(0, 4), Number(dateStr2.slice(4, 6)) - 1, dateStr2.slice(6, 8));

        // 날짜 간의 차이를 계산합니다. (밀리초 단위)
        const differenceMs = Math.abs(date1 - date2);

        // 밀리초를 일수로 변환합니다.
        dateRange = Math.ceil(differenceMs / (1000 * 60 * 60 * 24));

        //년, 월, 일로 리턴
        /*
        const yy = Math.floor(dateRage / 365);
        const mm = Math.floor((dateRage % 365) / 30);
        const dd = dateRage - yy * 365 - mm * 30;

        return { yy, mm, dd };
        */

        // 시작일자가 큰 경우 - 붙여줌
        if (!$valid.dateRange(dateStr1, dateStr2)) dateRange *= -1;
        return dateRange;
    }
}

const fclty = {
    getFcltyByBzno: async (bzno) => {
        const { data } = await $axios.get('/api/fclty/by-bzno', { params: { bzno } });
        return data;
    },
    getFcltyByFcltySn: async (fcltySn) => {
        const { data } = await $axios.get('/api/fclty/by-fclty-sn', { params: { fcltySn } });
        return data;
    },
    getFcltysByMberSn: async (getFcltysParams) => {
        const { data } = await $axios.get('/api/fclty/fcltys/by-mber-sn?' + txt.createQueryStr(getFcltysParams));
        return data;
    },
    getFcltyNmByFcltySn: async (fcltySn) => {
        const { data } = await $axios.get('/api/fclty/fclty-nm', { params: { fcltySn } });
        return data;
    },
    getFcltyMberNvtnCntByMberSn: async (mberSn) => {
        const { data } = await $axios.get('/api/fclty/mber-nvtns/by-mber-sn', { params: { mberSn } });
        return data.length;
    },
    getTxftStmnDatFilesByFcltySn: async (fcltySn) => {
        const { data } = await $axios.get('/api/fclty/txft-stmn-dat-files/by-fclty-sn', { params: { fcltySn } });
        return data;
    },
    getTxftStmnDat: async (fcltySn) => {
        const { data } = await $axios.get('/api/fclty/txft-stmn-dat', { params: { fcltySn } });
        return data;
    }
}

const svc = {
    getSeroiSvcId: () => {
        const SEROI_SVC_ID = 'SVC00001';
        return SEROI_SVC_ID;
    },
    getSeroiBsSvcGdsId: () => {
        const seroiGdsId = 'G0001';
        return seroiGdsId;
    },
    getSeroiYetdSvcGdsId: () => {
        const seroiGdsId = 'G0002';
        return seroiGdsId;
    },
    getSeroiLbscSvcId: () => {
        const svcId = 'SVC00002';
        return svcId;
    },
}

const router = {
    initRouterMvmn: (path, isNotNextCnd, notNextFunc, nextFunc) => {
        /* path: 히스토리와 비교할 대상
        * isCnd: next 처리를 안할 조건
        * notNextFunc: next 대신 처리할 func
        * nextFunc: router 이동할 next
        * */
        const history = window.history.state.forward;

        let isNext = true;
        if (history == path && isNotNextCnd) {
            notNextFunc()
            isNext = false;
        }

        nextFunc(isNext);
    }
}

const errorDefMsgTxt = '서버 오류입니다.';

const errorMsg = (e) => {
    console.error(e);
    let msg = errorDefMsgTxt;
    if (e?.response?.data?.msg) msg = e.response.data.msg;

    $alert(msg);
}

const useCmmn = () => {
    return {
        number,
        txt,
        date,
        fclty,
        svc,
        router,
        errorMsg,
        errorDefMsgTxt
    };
}

export { useCmmn };
